import { COLORS } from '@/config/colors';
import { SHADOWS } from '@/config/shadows';
import { TYPOGRAPHY } from './typography';

export const THEME_CONFIG = {
  colors: COLORS,
  shadows: SHADOWS,
  typography: TYPOGRAPHY
};
